import React, { createContext, useContext, useState, useEffect } from "react";

// Create the BookmarkContext
const BookmarkContext = createContext();

// BookmarkProvider component
export const BookmarkProvider = ({ children }) => {
  const [bookmarks, setBookmarks] = useState(() => {
    // Load initial bookmarks from local storage
    const savedBookmarks = localStorage.getItem("bookmarks");
    return savedBookmarks ? JSON.parse(savedBookmarks) : [];
  });

  // Function to toggle ID
  const toggleBookmark = (id) => {
    setBookmarks((prevBookmarks) => {
      let updatedBookmarks;
      if (prevBookmarks.includes(id)) {
        // If ID is already present, remove it
        updatedBookmarks = prevBookmarks.filter(
          (bookmarkId) => bookmarkId !== id
        );
      } else {
        // If ID is not present, add it
        updatedBookmarks = [...prevBookmarks, id];
      }
      // Save updated bookmarks to local storage
      localStorage.setItem("bookmarks", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });
  };

  // Sync with local storage whenever bookmarks change
  useEffect(() => {
    localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
  }, [bookmarks]);

  return (
    <BookmarkContext.Provider value={{ bookmarks, toggleBookmark }}>
      {children}
    </BookmarkContext.Provider>
  );
};

// Custom hook for using the context
export const useBookmarks = () => {
  return useContext(BookmarkContext);
};
